// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ArgSource } from "./arg-source";
import { FieldKind } from "./field-kind";

/**
 * One argument of an outbound command, in IDL argument order.
 */
export class CommandArg implements flatbuffers.IUnpackableObject<CommandArgT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): CommandArg {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsCommandArg(bb: flatbuffers.ByteBuffer, obj?: CommandArg): CommandArg {
    return (obj || new CommandArg()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsCommandArg(bb: flatbuffers.ByteBuffer, obj?: CommandArg): CommandArg {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new CommandArg()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  source(): ArgSource {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ArgSource.Constant;
  }

  width(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  kind(): FieldKind {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : FieldKind.Unsigned;
  }

  constant(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  /**
   * Added to the source value before `map`.
   */
  offset(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  /**
   * Replaces the value n with `map[n]`. Empty passes the value through. An
   * n below 0, or at or past the end, refuses the control.
   */
  map(index: number): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt64(this.bb!.__vector(this.bb_pos + offset) + index * 8) : 0n;
  }

  mapLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startCommandArg(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nameOffset, 0);
  }

  static addSource(builder: flatbuffers.Builder, source: ArgSource) {
    builder.addFieldInt8(1, source, ArgSource.Constant);
  }

  static addWidth(builder: flatbuffers.Builder, width: number) {
    builder.addFieldInt8(2, width, 0);
  }

  static addKind(builder: flatbuffers.Builder, kind: FieldKind) {
    builder.addFieldInt8(3, kind, FieldKind.Unsigned);
  }

  static addConstant(builder: flatbuffers.Builder, constant: bigint) {
    builder.addFieldInt64(4, constant, 0n);
  }

  static addOffset(builder: flatbuffers.Builder, offset: bigint) {
    builder.addFieldInt64(5, offset, 0n);
  }

  static addMap(builder: flatbuffers.Builder, mapOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, mapOffset, 0);
  }

  static createMapVector(builder: flatbuffers.Builder, data: bigint[]): flatbuffers.Offset {
    builder.startVector(8, data.length, 8);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt64(data[i]!);
    }
    return builder.endVector();
  }

  static startMapVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 8);
  }

  static endCommandArg(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createCommandArg(
    builder: flatbuffers.Builder,
    nameOffset: flatbuffers.Offset,
    source: ArgSource,
    width: number,
    kind: FieldKind,
    constant: bigint,
    offset: bigint,
    mapOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    CommandArg.startCommandArg(builder);
    CommandArg.addName(builder, nameOffset);
    CommandArg.addSource(builder, source);
    CommandArg.addWidth(builder, width);
    CommandArg.addKind(builder, kind);
    CommandArg.addConstant(builder, constant);
    CommandArg.addOffset(builder, offset);
    CommandArg.addMap(builder, mapOffset);
    return CommandArg.endCommandArg(builder);
  }

  unpack(): CommandArgT {
    return new CommandArgT(
      this.name(),
      this.source(),
      this.width(),
      this.kind(),
      this.constant(),
      this.offset(),
      this.bb!.createScalarList<bigint>(this.map.bind(this), this.mapLength()),
    );
  }

  unpackTo(_o: CommandArgT): void {
    _o.name = this.name();
    _o.source = this.source();
    _o.width = this.width();
    _o.kind = this.kind();
    _o.constant = this.constant();
    _o.offset = this.offset();
    _o.map = this.bb!.createScalarList<bigint>(this.map.bind(this), this.mapLength());
  }

  unpackFields(...fields: string[]): CommandArgT {
    const t = new CommandArgT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("source")) {
      t.source = this.source();
    }
    if (fieldSet.has("width")) {
      t.width = this.width();
    }
    if (fieldSet.has("kind")) {
      t.kind = this.kind();
    }
    if (fieldSet.has("constant")) {
      t.constant = this.constant();
    }
    if (fieldSet.has("offset")) {
      t.offset = this.offset();
    }
    if (fieldSet.has("map")) {
      t.map = this.bb!.createScalarList<bigint>(this.map.bind(this), this.mapLength());
    }
    return t;
  }
}

export class CommandArgT implements flatbuffers.IGeneratedObject {
  constructor(
    public name: string | Uint8Array | null = null,
    public source: ArgSource = ArgSource.Constant,
    public width: number = 0,
    public kind: FieldKind = FieldKind.Unsigned,
    public constant: bigint = 0n,
    public offset: bigint = 0n,
    public map: bigint[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const map = CommandArg.createMapVector(builder, this.map);

    return CommandArg.createCommandArg(
      builder,
      name,
      this.source,
      this.width,
      this.kind,
      this.constant,
      this.offset,
      map,
    );
  }

  clone(): CommandArgT {
    const obj = new CommandArgT();
    obj.name = this.name;
    obj.source = this.source;
    obj.width = this.width;
    obj.kind = this.kind;
    obj.constant = this.constant;
    obj.offset = this.offset;
    obj.map = [...this.map];
    return obj;
  }

  equals(other: CommandArgT): boolean {
    if (this.name !== other.name) return false;
    if (this.source !== other.source) return false;
    if (this.width !== other.width) return false;
    if (this.kind !== other.kind) return false;
    if (this.constant !== other.constant) return false;
    if (this.offset !== other.offset) return false;
    if (this.map.length !== other.map.length) return false;
    for (let i = 0; i < this.map.length; i++) {
      if (this.map[i] !== other.map[i]) return false;
    }
    return true;
  }
}

export function verifyCommandArg(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 8);
    verifier.checkScalarField(tablePos, 14, 8);
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkVector(pos, 8);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
